import { render, staticRenderFns } from "./Recomendadas.vue?vue&type=template&id=dd5d3476"
import script from "./Recomendadas.vue?vue&type=script&lang=js"
export * from "./Recomendadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports